import React, { useState, useEffect } from 'react';
import Header from '../../../common/components/Header/Header';
import Sidebar from '../../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../../data/SiteConfig';
import styles from '../styles.module.css';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import InPrincipalView from '../InPrincipalView/InPrincipalView';
import PDFDocument from '../PDFDocument/PDFDocument';
import PopUp from '../../../common/components/PopUp/PopUp';
import backBtn_icon from '../../../images/icons/backBtn_icon.svg';
import { navigate } from 'gatsby';
import CreditReport from '../../CreditReport/CreditReport';
import CMDetailView, {
  ReadOnly
} from '../../../containers/CMDashboard/CMDetailView';
import { viewCreditReportRmBpSide } from '../../../common/constants/api';
import { staticData } from 'gatsby-env-variables';
const LeadProfileDocView = props => {
  const { leadstyle, backPage } = styles;
  const [showFullImage, setFullImage] = useState(false);
  const [isError, setIsError] = useState(false);
  const [file, setFile] = useState(false);
  const [highlightedOpt, setHighlightedOpt] = useState(0);

  const [showAnalyseBtn, setShowAnalyseBtn] = useState(false);
  const [analyzeTheBre, setAnalyzeTheBre] = useState(undefined);

  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
  const [showPDFDoc, setShowPDFDoc] = useState(true);
  const [backButtonUrl, setBackButtonUrl] = useState(`/app/leadprofile`);
  const { typeleadprofile, applicantId } = props;

  const isInprinciple = typeleadprofile === 'inprinciple';
  const isDocView = typeleadprofile === 'document';
  const isCreditReport = typeleadprofile === 'creditReport';
  const isviewAllDocs = typeleadprofile == 'documents';

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.get('backPage') == 'cmView')
      setBackButtonUrl(
        `app/documents/leadId/${leadId}?currentState=creditReport`
      );
    else if (urlParams.get('backPage') == 'allLeads')
      setBackButtonUrl(`/app/dashboard?type=leads`);
  }, []);

  useEffect(() => {
    setAnalyzeTheBre(!analyzeTheBre);
  }, []);

  return (
    <React.Fragment>
      <Helmet title={`Dashboard RM | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-hidden font-roboto text-sm font-normal m-0 p-0">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />

          <div className="widhtMd max-screen flex-1  w-full ">
            <span className={`${leadstyle}`}>Lead ID - {leadId}</span>
            <div className="w-full flex items-center ml-auto">
              {showAnalyseBtn === 'BRE' && (
                <button
                  className="bg-green-tePapaGreen text-white font-open-sans text-sm px-7 py-2 rounded shadow-inner shadow-md text-center ml-auto  float-right mr-2"
                  onClick={() => setAnalyzeTheBre(e => !e)}
                >
                  Analyze
                </button>
              )}
              <div
                className={`${showAnalyseBtn == 'BRE' ? 'table' : 'w-full'}`}
              >
                <Header />
              </div>
            </div>
            <div
              className="ml-10 mt-4 md:mt-0 cursor-pointer"
              onClick={() => {
                navigate(backButtonUrl);
              }}
            >
              <img src={backBtn_icon} alt="" />
            </div>
            {isInprinciple && <InPrincipalView />}
            {isDocView && (
              <PDFDocument
                showPDFDoc={showPDFDoc}
                setShowPDFDoc={setShowPDFDoc}
              />
            )}
            {isCreditReport && !staticData?.isLems ? <CreditReport /> : null}
            {isCreditReport && staticData?.isLems && (
              <CreditReport
                getcreditReportApi={() =>
                  viewCreditReportRmBpSide(
                    getApplicantionInfo().leadId,
                    applicantId || getApplicantionInfo().leadApplicantId
                  )
                }
              />
            )}
            {isviewAllDocs ? (
              <ReadOnly.Provider value={true}>
                <CMDetailView
                  setHighlightedOpt={setHighlightedOpt}
                  setFullImage={setFullImage}
                  setIsError={setIsError}
                  setFile={setFile}
                  setShowAnlyseButton={setShowAnalyseBtn}
                  analyzeTheBre={analyzeTheBre}
                  setShowAnalyseBtn={setAnalyzeTheBre}
                />
              </ReadOnly.Provider>
            ) : null}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LeadProfileDocView;
